export default __webpack_public_path__ + "static/media/folio-light.3bb07e3c.svg";